/**
 * Time-of-day picker placeholder.
 *
 * Voluum's `path_condition_TimeOfDayConditionResource` requires `startTime`,
 * `endTime`, and `timeZone`. We display a read-only summary derived from the
 * existing condition payload (preserved untouched on save) until we ship a
 * dedicated time-zone-aware editor. Users can still toggle the predicate.
 */

import type { FC } from 'react';
import { Info } from 'lucide-react';

export interface TimeOfDayHintProps {
  hint?: string;
}

const TimeOfDayHint: FC<TimeOfDayHintProps> = ({
  hint = 'Time of day stays as-configured in Voluum. Change it from the Voluum UI.',
}) => (
  <p className="flex items-center gap-1.5 text-[11px] italic text-muted-foreground">
    <Info className="h-3 w-3 shrink-0" aria-hidden />
    {hint}
  </p>
);

export default TimeOfDayHint;
